<template>
  <footer class="bg-pur font-small text-white pt-4">
    <b-container fluid>
      <b-row class="text-center text-md-left">
        <b-col md="4">
          <h4 class="font-weight-bold text-left">{{ShopName}}</h4>
        </b-col>
        <b-col md="5"></b-col>
        <b-col md="3">
          <ul class="list-unstyled">
            <li class="mb-3">服務專線 | {{ShopTel}}</li>
            <li class="mb-3">服務信箱 | {{ShopEmail}}</li>
			<li class="mb-3">聯絡地址 | {{ShopAddress}}</li>
			<li>服務時間 | {{ShopServiceTime}}</li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <div class="footer-copyright text-left py-3">
      © 2019 Hash Tech Inc. All Rights Reversed.
    </div>
  </footer>
</template>

<script>
import { State } from '../library/EventBus.js'
export default {
  computed: {
    ShopName () {
      return State.footer.name || ''
    },
    ShopAddress () {
      return State.footer.address || ''
    },
    ShopTel () {
      return State.footer.tel || ''
    },
    ShopEmail () {
      return State.footer.email || ''
    },
    ShopServiceTime () {
      return State.footer.service_time || ''
    }
  }
}
</script>
<style scoped>
  footer .container-fluid, .footer-copyright {
    width: 83%;
  }
  .footer-copyright {
	margin: 0 auto;
	padding-left: 15px;
	color: rgba(255,255,255,.5);
  }
  .bg-pur {
    background-color: #5364b5
  }
</style>